import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraTelefone,aplicarMascaraCEP} from "../../../../lib/formatarCampos";
const initialClientesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  clienteForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const clientesSlice = createSlice({
  name: "clientes",
  initialState: initialClientesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getClienteById
    clienteFetched: (state, action) => {


      state.listLoading = false;
      // APLICAR A MASCARA
      state.clienteForEdit = action.payload.clienteForEdit;
      state.error = null;

    },
    // findClientes
    clientesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createCliente
    clienteCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities.push(action.payload.cliente);
    },
    // updateCliente
    clienteUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.cliente.id) {
          return action.payload.cliente;
        }
        return entity;
      });
    },
    // deleteCliente
    clienteDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteClientes
    clientesDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // clientesUpdateState
    clientesStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
